import { env } from "@/configs/env";
import forge from "node-forge";

/**
 * AEA-55 / AD-9 — Resolve a chave em PEM a partir do valor do env, tolerando os
 * formatos comuns de colagem: PEM cru, PEM com "\n" escapado, ou PEM em base64.
 */
const resolvePem = (secret: string): string => {
  if (secret.includes("-----BEGIN")) return secret.replace(/\\n/g, "\n");
  return forge.util.decode64(secret);
};

/**
 * Cifra os dados do cartão com a chave PÚBLICA RSA (RSA-OAEP). A pública pode ser
 * pública por desenho; a privada vive apenas no backend.
 */
export const tokenGenerate = (data: string): string => {
  const publicKey = forge.pki.publicKeyFromPem(resolvePem(env.payment_secret!));
  const encrypted = publicKey.encrypt(data, "RSA-OAEP");

  return forge.util.encode64(encrypted);
};
